import { gql } from "@kv/apollo-client";



export const GetAuthTokens = gql`
  query GetAuthTokens {
    authTokens {
      accessToken
    }
  }
`;

export const UserLogin = gql`
  mutation UserLogin($input: UserLoginInput!) {
    userLogin(input: $input) {
      accessToken
      error {
        code
        message
      }
    }
  }
`;

export const UserLogout = gql`
  mutation UserLogout {
    userLogout {
      error {
        code
        message
      }
    }
  }
`;
